module.exports = __webpack_public_path__ + "img/qy (55).c2832b43.png";